/*
  Stoff und Stahl — Pannenmeldung aus dem Browser (20.10.2026).

  Nur hinsehen, nichts heilen. Scheitert beim Kunden das Verkleinern oder das
  Hochladen eines Fotos, geht eine kurze Meldung an den Server. Ohne sie steht
  in der Datenbank nur „neu" und sonst nichts: Am 19./20.10.2026 blieben drei
  Vorschauen stehen, und von aussen war nicht zu unterscheiden, ob der Upload
  gar nicht lief, unterwegs abbrach oder der Browser nur die Antwort verlor.

  Was mitgeht: Fehlerart, Geraet, Browser (auch die App-Browser von TikTok und
  Instagram), Dateigroesse, Format und Aufloesung.
  Was NICHT mitgeht: kein Foto, keine Mailadresse, kein Name, keine Adresse.

  Die Meldung darf unter keinen Umstaenden den Ablauf stoeren. Deshalb:
  - alles in einem eigenen try, der jeden Fehler schluckt;
  - sendBeacon, das nie wirft und nie abgewartet wird;
  - als Abfrageparameter statt im Rumpf, sonst loest sie eine CORS-Vorabanfrage
    aus, die ein Beacon nicht fuehren kann und der Browser wirft ihn lautlos weg
    (gelernt an der Messung am 19.10.2026).

  Eine Datei fuer alle drei Einstiege (Vorschau-Seite, Produktseite, Warenkorb),
  damit die Geraeteerkennung nicht an drei Stellen gepflegt werden muss.
*/
(() => {
  if (window.susPanne) return;

  const UA = String((navigator && navigator.userAgent) || '');

  const geraet = () => {
    if (/iPad/i.test(UA)) return 'iPad';
    if (/iPhone|iPod/i.test(UA)) return 'iPhone';
    if (/Android/i.test(UA)) return 'Android';
    if (/Macintosh|Mac OS X/i.test(UA)) return 'Mac';
    if (/Windows/i.test(UA)) return 'Windows';
    return 'sonst';
  };

  // Die App-Browser zuerst: TikTok und Instagram nennen sich zusaetzlich Safari
  // oder Chrome, eine Pruefung in der falschen Reihenfolge sieht sie nie.
  const browser = () => {
    if (/BytedanceWebview|musical_ly|TikTok|Bytelo/i.test(UA)) return 'TikTok';
    if (/Instagram/i.test(UA)) return 'Instagram';
    if (/FBAN|FBAV|FB_IAB|FBIOS/i.test(UA)) return 'Facebook';
    if (/Snapchat/i.test(UA)) return 'Snapchat';
    if (/Pinterest/i.test(UA)) return 'Pinterest';
    if (/Line\//i.test(UA)) return 'Line';
    if (/EdgA?\//i.test(UA)) return 'Edge';
    if (/OPR\/|Opera/i.test(UA)) return 'Opera';
    if (/SamsungBrowser/i.test(UA)) return 'Samsung';
    if (/FxiOS|Firefox/i.test(UA)) return 'Firefox';
    if (/CriOS|Chrome/i.test(UA)) return 'Chrome';
    if (/Safari/i.test(UA)) return 'Safari';
    return 'sonst';
  };

  const art = (fehler) => {
    if (!fehler) return 'unbekannt';
    if (typeof fehler === 'string') return fehler;
    const name = String(fehler.name || '');
    const text = String(fehler.message || '');
    return (name && text ? name + ': ' + text : name || text || 'unbekannt');
  };

  // Auch einzeln nutzbar: stoffundstahl-problem.js braucht dieselbe Erkennung
  // fuer den Knopf "Problem melden". Zweimal pflegen waere genau das Muster,
  // das in CLAUDE.md schon viermal schiefgegangen ist.
  window.susPanneGeraet = geraet;
  window.susPanneBrowser = browser;

  window.susPanne = (basis, schritt, fehler, zusatz) => {
    try {
      const z = zusatz || {};
      const teile = {
        schritt: String(schritt || 'unbekannt'),
        art: art(fehler).slice(0, 160),
        geraet: geraet(),
        browser: browser(),
        ua: UA.slice(0, 200),
        quelle: z.quelle || '',
        ansicht: z.ansicht || '',
        bytes: z.bytes == null ? '' : String(z.bytes),
        format: z.format || '',
        breite: z.breite == null ? '' : String(z.breite),
        hoehe: z.hoehe == null ? '' : String(z.hoehe),
        kennung: z.kennung || '',
      };
      const abfrage = Object.keys(teile)
        .filter((k) => teile[k] !== '')
        .map((k) => k + '=' + encodeURIComponent(teile[k]))
        .join('&');
      const ziel = String(basis || '').replace(/\/$/, '')
        + '/webhook/vorschau/panne?' + abfrage;
      if (navigator.sendBeacon) navigator.sendBeacon(ziel);
      else fetch(ziel, { method: 'POST', keepalive: true }).catch(() => {});
    } catch (e) { /* Eine Meldung darf nie etwas kaputtmachen */ }
  };
})();
